export class ConfigurationError extends Error {
    name = 'ConfigurationError';
}
